var timeago = {
    bindings : {
        date : '@'
    },
    controller : function TimeagoCtrl () {
        var ctrl = this;

        function link () {
            ctrl.fromNow = moment(ctrl.date, 'YYYY-MM-DD HH:mm:ss').fromNow();
        }

        this.$postLink = link;
    },
    template : '<span ng-bind="$ctrl.fromNow"></span>'
}